(() => {
  'use strict';
  const configElement = document.getElementById('prison-newsletter-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const campaign = config.welcome;
  if (!campaign?.enabled || window.__prisonWelcomeControllerStarted) return;
  window.__prisonWelcomeControllerStarted = true;
  const preview = config.preview_allowed && new URLSearchParams(location.search).get('preview_newsletter') === '1';
  const key = '_mn_' + campaign.id;
  const sessionKey = 'prison.welcome.visit.v2';
  const formId = 'PrisonWelcomeForm';
  const modalId = 'newsletterModal_prisonWelcome';
  const letterKey = 'prison.welcome.letter.hidden.v1';
  let opened = false;
  let timer;
  let letter;
  let letterHidden = false;

  function dismissed() {
    if (preview) return false;
    try {
      const cookie = document.cookie.split('; ').find(part => part.startsWith(key + '='));
      if (cookie) {
        const record = JSON.parse(atob(cookie.slice(key.length + 1)));
        if (Number(record.expires) > Date.now()) return true;
      }
    } catch {}
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        const record = JSON.parse(window[storage].getItem(key));
        if (Number(record?.expires) > Date.now()) return true;
      } catch {}
    }
    return false;
  }

  function remember() {
    if (preview) return;
    const expires = Date.now() + 3600000;
    const record = { version: 'prison-v2', popup: campaign.id, expires, triggerMode: 'DELAYED', frequencyType: 'HOUR' };
    document.cookie = key + '=' + btoa(JSON.stringify(record)) + '; expires=' + new Date(expires).toUTCString() + '; path=/; SameSite=Lax; Secure';
    try { localStorage.setItem(key, JSON.stringify(record)); } catch {}
  }

  function create(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function show(manual = false) {
    if (document.getElementById(modalId)) return;
    if (!manual && (opened || dismissed() || letterHidden)) return;
    if (document.hidden) return;
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:checkouts?|challenge|account)(?:\/|$)/i.test(location.pathname)) return;
    if (!manual) {
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const dialogOpen = [...document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open]')]
        .some(element => {
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return rect.width > 0 && rect.height > 0 && rect.left < document.documentElement.clientWidth
            && rect.right > 0 && rect.top < window.innerHeight && rect.bottom > 0
            && style.visibility !== 'hidden' && Number(style.opacity) > 0;
        });
      if (editing || dialogOpen) { timer = setTimeout(() => show(), 1000); return; }
    }
    clearTimeout(timer);
    opened = true;
    if (letter) {
      letter.hidden = true;
      letter.querySelector('[data-prison-letter-open]')?.setAttribute('aria-expanded', 'true');
    }
    const modal = create('div', 'newsletter-modal-prisonWelcome');
    modal.id = modalId;
    const panel = create('div', 'modal-container-prisonWelcome');
    panel.style.backgroundImage = 'url("' + campaign.image + '")';
    const form = create('form', 'form-container-prisonWelcome');
    form.id = formId;
    form.noValidate = true;
    form.method = 'post';
    const heading = create('h2', 'title-prisonWelcome', config.strings.title);
    const hint = create('p', '', 'Preencha com os dados de quem fará a compra.');
    hint.setAttribute('data-prison-buyer-hint', '');
    hint.id = formId + '-hint';
    form.setAttribute('aria-describedby', hint.id);
    form.append(heading, hint);
    const fields = {};
    for (const [name, label, type, autocomplete, maximum] of [
      ['name', 'Nome', 'text', 'name', 120],
      ['email', 'E-mail', 'email', 'email', 254],
      ['phone', 'WhatsApp', 'tel', 'tel-national', 20]
    ]) {
      const group = create('div', 'form-group');
      const input = create('input', 'outlined-input');
      input.id = formId + '-' + name;
      input.name = name;
      input.type = type;
      input.placeholder = ' ';
      input.required = true;
      input.maxLength = maximum;
      input.autocomplete = autocomplete;
      if (name !== 'name') input.inputMode = name === 'email' ? 'email' : 'tel';
      const caption = create('label', 'outlined-label', label + '*');
      caption.htmlFor = input.id;
      const error = create('span', '', '');
      error.id = input.id + '-error';
      error.setAttribute('data-prison-field-error', '');
      error.hidden = true;
      input.setAttribute('aria-describedby', hint.id + ' ' + error.id);
      input.addEventListener('input', () => {
        group.classList.remove('error');
        input.removeAttribute('aria-invalid');
        error.hidden = true;
      });
      group.append(input, caption, error);
      form.append(group);
      fields[name] = { input, group, error };
    }
    const submit = create('button', 'btn-send', config.strings.release);
    submit.type = 'submit';
    const status = create('p');
    status.setAttribute('data-prison-register-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.hidden = true;
    form.append(submit, status);
    const close = create('button', 'btn-close-prisonWelcome');
    close.type = 'button';
    close.setAttribute('aria-label', 'Fechar pop-up');
    close.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    const dismiss = () => {
      remember();
      modal.remove();
      if (letter) {
        letter.hidden = letterHidden;
        letter.querySelector('[data-prison-letter-open]')?.setAttribute('aria-expanded', 'false');
      }
    };
    close.addEventListener('click', dismiss);
    modal.addEventListener('click', event => { if (event.target === modal) dismiss(); });
    panel.append(form, close);
    modal.append(panel);

    function message(text, failed = false) {
      status.textContent = text;
      status.hidden = !text;
      status.dataset.error = String(failed);
      if (failed) status.scrollIntoView({ block: 'nearest' });
    }

    function invalid(name, text) {
      const field = fields[name];
      field.group.classList.add('error');
      field.input.setAttribute('aria-invalid', 'true');
      field.error.textContent = text;
      field.error.hidden = false;
    }

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      const name = fields.name.input.value.trim();
      const email = fields.email.input.value.trim();
      let phone = fields.phone.input.value.replace(/\D/g, '');
      if (phone.length === 13 && phone.startsWith('55')) phone = phone.slice(2);
      Object.values(fields).forEach(field => {
        field.group.classList.remove('error');
        field.error.hidden = true;
        field.input.removeAttribute('aria-invalid');
      });
      if (!name) invalid('name', 'Informe o nome de quem fará a compra.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254) invalid('email', 'Confira o endereço de e-mail.');
      if (!/^\d{11}$/.test(phone)) invalid('phone', 'Informe o DDD e os 9 dígitos do celular.');
      const firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid) { message('Confira os campos indicados.', true); firstInvalid.focus(); return; }
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      submit.textContent = 'ENVIANDO…';
      message('Aguarde um instante. Estamos confirmando seu cadastro.');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        if (!preview) {
          const response = await fetch(campaign.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({ name, email, phone, page: location.href, 'opt-in': null, document: null, birthdate: null, honeypot: '', newsletter_id: campaign.id })
          });
          if (!response.ok) throw new Error('registration-not-confirmed');
          try { sessionStorage.setItem('prison.newsletter.checkout.v1', JSON.stringify({ name, email, savedAt: Date.now() })); } catch {}
        }
        remember();
        const title = create('h2', '', config.strings.success_title);
        const code = create('p', '', config.coupon);
        const button = create('button', 'btn-go', config.strings.apply);
        button.type = 'button';
        form.replaceChildren(title, code, button);
      } catch (error) {
        submit.disabled = false;
        submit.textContent = config.strings.release;
        message(error.name === 'AbortError'
          ? 'O cadastro demorou mais que o esperado. Seus dados foram mantidos; tente novamente.'
          : 'Não foi possível confirmar o cadastro. Confira sua conexão e tente novamente.', true);
      } finally {
        clearTimeout(timeout);
        form.dataset.submitting = 'false';
        form.removeAttribute('aria-busy');
      }
    });
    document.body.append(modal);
    remember();
  }

  function start() {
    letter = document.querySelector('[data-prison-letter]');
    if (letter) {
      try { letterHidden = !preview && sessionStorage.getItem(letterKey) === '1'; } catch {}
      letter.hidden = letterHidden;
      letter.querySelector('[data-prison-letter-open]')?.addEventListener('click', () => show(true));
      letter.querySelector('[data-prison-letter-dismiss]')?.addEventListener('click', () => {
        letterHidden = true;
        letter.hidden = true;
        clearTimeout(timer);
        remember();
        if (!preview) { try { sessionStorage.setItem(letterKey, '1'); } catch {} }
      });
    }
    document.addEventListener('prison:welcome:open', () => show(true));
    if (dismissed() || letterHidden) return;
    let started = Date.now();
    if (!preview) {
      try {
        const saved = Number(sessionStorage.getItem(sessionKey));
        if (saved > 0 && saved <= started && started - saved < 3600000) started = saved;
        else sessionStorage.setItem(sessionKey, String(started));
      } catch {}
    }
    const delay = Math.max(0, Number(campaign.delay_ms) || 8000);
    const wait = Math.max(0, delay - (Date.now() - started));
    timer = setTimeout(() => show(), wait);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && Date.now() - started >= delay) show();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

